export const fuels = { 'Liquid Fuels': {
    "Aviation spirit": { name: "Aviation spirit", unit: "litre(s)", ef: 2.33048 },
    "Aviation turbine fuel": { name: "Aviation turbine fuel", unit: "litre(s)", ef: 2.54514 },
    "Burning oil": { name: "Burning oil", unit: "litre(s)", ef: 2.54014 },
    "Diesel (average biofuel blend)": { name: "Diesel (average biofuel blend)", unit: "litre(s)", ef: 2.51233 },
    "Diesel (100% mineral diesel)": { name: "Diesel (100% mineral diesel)", unit: "litre(s)", ef: 2.70553 },
    "Fuel oil": { name: "Fuel oil", unit: "litre(s)", ef: 3.17522 },
    "Gas oil": { name: "Gas oil", unit: "litre(s)", ef: 2.75857 },
    "Lubricants": { name: "Lubricants", unit: "litre(s)", ef: 2.75 },
    "Naphtha": { name: "Naphtha", unit: "litre(s)", ef: 2.12 },
    "Petrol (average biofuel blend)": { name: "Petrol (average biofuel blend)", unit: "litre(s)", ef: 2.19352 },
    "Petrol (100% mineral petrol)": { name: "Petrol (100% mineral petrol)", unit: "litre(s)", ef: 2.33969 },
    "Processed fuel oils - residual oil": { name: "Processed fuel oils - residual oil", unit: "litre(s)", ef: 3.17522 },
    "Processed fuel oils - distillate oil": { name: "Processed fuel oils - distillate oil", unit: "litre(s)", ef: 2.75857 },
    "Waste oils": { name: "Waste oils", unit: "litre(s)", ef: 2.75 },
    "Marine gas oil": { name: "Marine gas oil", unit: "litre(s)", ef: 2.77539 },
    "Marine fuel oil": { name: "Marine fuel oil", unit: "litre(s)", ef: 3.10669 }
  },
  'Solid Fuels': {
    "Coal (industrial)": { name: "Coal (industrial)", unit: 'kg', ef: 2.40384 },
    "Coal (electricity generation)": { name: "Coal (electricity generation)", unit: 'kg', ef: 2.25234 },
    "Coal (domestic)": { name: "Coal (domestic)", unit: 'kg', ef: 2.88326 },
    "Coking coal": { name: "Coking coal", unit: 'kg', ef: 3.16524 },
    "Petroleum coke": { name: "Petroleum coke", unit: 'kg', ef: 3.38686 },
    "Coal (electricity generation - home produced coal only)": { name: "Coal (electricity generation - home produced coal only)", unit: 'kg', ef: 2.24882 }
  },
  'Gaseous Fuels': {
    "CNG": { name: "CNG", unit: "litre(s)", ef: 1.75 },
    "LNG": { name: "LNG", unit: "litre(s)", ef: 0.44423 },
    "LPG": { name: "LPG", unit: "litre(s)", ef: 1.15623 },
    "Natural gas": { name: "Natural gas", unit: "m3", ef: 1.55709 },
    "Natural gas (100% mineral blend)": { name: "Natural gas (100% mineral blend)", unit: "m3", ef: 2.02135 },
    "Other petroleum gas": { name: "Other petroleum gas", unit: "litre(s)", ef: 2.03473 },
    "Propane": { name: "Propane", unit: "litre(s)", ef: 0.94441 }
  },
  'Biofuels': {
    "Bioethanol": { name: "Bioethanol", unit: "litre(s)", ef: 0.00901 },
    "Biodiesel ME": { name: "Biodiesel ME", unit: "litre(s)", ef: 0.00521 },
    "Biomethane": { name: "Biomethane", unit: "kg", ef: 0.16751 },
    "Biodiesel ME (from used cooking oil)": { name: "Biodiesel ME (from used cooking oil)", unit: "litre(s)", ef: 0.16751 },
    "Biodiesel ME (from tallow)": { name: "Biodiesel ME (from tallow)", unit: "litre(s)", ef: 0.03558 },
    "Biodiesel HVO": { name: "Biodiesel HVO", unit: "litre(s)", ef: 0.00214 },
    "Biopropane": { name: "Biopropane", unit: "litre(s)", ef: 0.01402 },
    "Bio Petrol": { name: "Bio Petrol", unit: "litre(s)", ef: 0.01010 },
    "Renewable petrol": { name: "Renewable petrol", unit: "litre(s)", ef: 0.01010 }
  },
  'Biomass': {
    "Wood logs": { name: "Wood logs", unit: 'kg', ef: 0.06181736 },
    "Wood chips": { name: "Wood chips", unit: 'kg', ef: 0.05715269 },
    "Wood pellets": { name: "Wood pellets", unit: 'kg', ef: 0.07261754 },
    "Grass/straw": { name: "Grass/straw", unit: 'kg', ef: 0.04923656 }
  },
  'Biogass': {
    "Biogas": { unit: 'kg', ef: 0.00121518 },
    "Landfill gas": { unit: 'kg', ef: 0.00068793 }
  },
}

export const operations = {
  "Soil cultivation": {
    "Plowing - Average": 23,
    "Plowing - Light soil": 15,
    "Plowing - Heavy soil": 40,
    "Subsoiler": 21,
    "Stub harrow": 9,
    "Deep harrow": 15,
    "Spring tine harrow (Fine harrow)": 7,
    "Harrow with seedbed combination": 6,
    "Disc harrow": 7,
    "Rotary harrow": 10,
    "Milling": 12
  },
  "Sowing, Planting": {
    "Precision sowing – Beets, Corn": 5,
    "Mulch – Precision sowing – Corn": 11,
    "Drill sowing": 5,
    "Combination Rotary harrow + Seed drill": 15,
    "Combination Milling machine + Seed drill": 15,
    "Combination Tine rotor + Seed drill": 15,
    "Direct sowing": 9,
    "Potato planting, semi-automatic": 20,
    "Potato planting, fully automatic": 15
  },
  "Mineral fertilizer application": {
    "Mounted centrifugal spreader": 1.5,
    "Mounted pneumatic spreader": 2.5,
    "Lime application": 2.5
  },
  "Chemical plant protection": {
    "Field sprayer": 2
  },
  "Mechanical plant protection": {
    "Harrowing": 3.5,
    "Corn hoeing with star hoe device": 4,
    "Corn hoeing with hoeing machine": 5,
    "Hoeing and harrowing": 5.5,
    "Hoeing of beets": 5,
    "Ridging of potatoes": 5,
    "Flaming": 4
  },
  "Care": {
    "Dragging": 4,
    "Rolling": 3.5
  },
  "Organic fertilizer application": {
    "Manure spreading": 14,
    "Vacuum tanker": 6,
    "Pump tanker – Drag hose": 7
  },
  "Forage harvesting – Grassland": {
    "Bar mower – Mounted": 3,
    "Rotary mower – Mounted": 5,
    "Rotary mower with conditioner": 6,
    "Self-propelled rotary mower with conditioner": 6,
    "Rotary tedder": 3,
    "Rotary swather": 4,
    "Loader wagon for ventilated hay collection": 7,
    "Loader wagon for wilted material collection": 9,
    "Precision field chopper": 12
  },
  "Forage harvesting – Silage maize": {
    "Precision field chopper": 34
  },
  "Combine harvesting": {
    "Grain, Sunflowers, Rapeseed, Field beans": 22,
    "Peas": 27,
    "Grain maize": 25
  },

  //NUMBER OF BALES
  "Root crop harvesting": {
    "Potato harvester": 52,
    "Potato harvester – Self-propelled": 51,
    "Potato lifter": 32,
    "Potato lifter – Self-propelled": 39,
    "Sugar beet harvester": 49,
    "Sugar beet harvester – Self-propelled": 53
  },
  "Fruit farming": {
    "Mulching – Flail mower": 10,
    "Winter pruning – Flail mower": 26,
    "Plant protection – Saddle sprayer": 7,
    "Mineral fertilization – Fertilizer spreader": 7.5
  },
  "Viticulture": {
    "Tilling of driveways": 11,
    "Cultivating": 11,
    "Rolling": 4,
    "Leaf cutting": 8,
    "Mulching – Flail mower": 12,
    "Plant protection – Saddle sprayer": 5,
    "Hilling, plowing of vine rows": 20,
    "Clearing vine stock area": 18,
    "Subsoil loosening (Rotary plow)": 20,
    "Harvesting with grape harvester": 20,
    "Mowing – Disc mower": 20,
    "Sowing greening": 3,
    "Chopping vine wood": 7
  }
}

export const formatOperationCategories = () => {
  return Object.keys(operations).map((category) => ({ value: category, label: category }));
}

export const formatOperations = (category) => {
  if (!category) {
    return [];
  }
  return Object.keys(operations[category]).map((operation) => ({ value: operation, label: operation }));
}


//"Motor power [kW] / [HP] and engine load"
export const motorPower = {

  "20 / 27": { "Low (20%)": 1.3, "Medium (40%)": 2.6, "High (70%)": 4.6 },
  "25 / 34": { "Low (20%)": 1.7, "Medium (40%)": 3.3, "High (70%)": 5.8 },
  "30 / 41": { "Low (20%)": 2.0, "Medium (40%)": 4.0, "High (70%)": 6.9 },
  "35 / 47": { "Low (20%)": 2.3, "Medium (40%)": 4.6, "High (70%)": 8.1 },
  "40 / 54": { "Low (20%)": 2.6, "Medium (40%)": 5.3, "High (70%)": 9.2 },
  "45 / 61": { "Low (20%)": 3.0, "Medium (40%)": 5.9, "High (70%)": 10.4 },
  "50 / 68": { "Low (20%)": 3.3, "Medium (40%)": 6.6, "High (70%)": 11.6 },
  "55 / 75": { "Low (20%)": 3.6, "Medium (40%)": 7.3, "High (70%)": 12.7 },
  "60 / 82": { "Low (20%)": 4.0, "Medium (40%)": 7.9, "High (70%)": 13.9 },
  "65 / 88": { "Low (20%)": 4.3, "Medium (40%)": 8.6, "High (70%)": 15.0 },
  "70 / 95": { "Low (20%)": 4.6, "Medium (40%)": 9.2, "High (70%)": 16.2 },
  "75 / 102": { "Low (20%)": 5.0, "Medium (40%)": 9.9, "High (70%)": 17.3 },
  "80 / 109": { "Low (20%)": 5.3, "Medium (40%)": 10.6, "High (70%)": 18.5 },
  "85 / 116": { "Low (20%)": 5.6, "Medium (40%)": 11.2, "High (70%)": 19.6 },
  "90 / 122": { "Low (20%)": 5.9, "Medium (40%)": 11.9, "High (70%)": 20.8 },
  "100 / 136": { "Low (20%)": 6.6, "Medium (40%)": 13.2, "High (70%)": 23.1 },
  "110 / 150": { "Low (20%)": 7.3, "Medium (40%)": 14.5, "High (70%)": 25.4 },
  "120 / 163": { "Low (20%)": 7.9, "Medium (40%)": 15.8, "High (70%)": 27.7 },
  "130 / 177": { "Low (20%)": 8.6, "Medium (40%)": 17.2, "High (70%)": 30.0 },
  "140 / 190": { "Low (20%)": 9.2, "Medium (40%)": 18.5, "High (70%)": 32.3 },
  "150 / 204": { "Low (20%)": 9.9, "Medium (40%)": 19.8, "High (70%)": 34.7 },
  "160 / 218": { "Low (20%)": 10.6, "Medium (40%)": 21.1, "High (70%)": 37.0 },
  "170 / 231": { "Low (20%)": 11.2, "Medium (40%)": 22.4, "High (70%)": 39.3 },
  "180 / 245": { "Low (20%)": 11.9, "Medium (40%)": 23.8, "High (70%)": 41.6 },
  "190 / 258": { "Low (20%)": 12.5, "Medium (40%)": 25.1, "High (70%)": 43.9 },
  "190 / 258": { "Low (20%)": 12.5, "Medium (40%)": 25.1, "High (70%)": 43.9 },
  "200 / 272": { "Low (20%)": 13.2, "Medium (40%)": 26.4, "High (70%)": 46.2 },
  "220 / 299": { "Low (20%)": 14.5, "Medium (40%)": 29.0, "High (70%)": 50.8 },
  "240 / 326": { "Low (20%)": 15.8, "Medium (40%)": 31.7, "High (70%)": 55.4 },
  "260 / 354": { "Low (20%)": 17.2, "Medium (40%)": 34.3, "High (70%)": 60.1 },
  "280 / 381": { "Low (20%)": 18.5, "Medium (40%)": 37.0, "High (70%)": 64.7 },
  "300 / 408": { "Low (20%)": 19.8, "Medium (40%)": 39.6, "High (70%)": 69.3 },
  "320 / 435": { "Low (20%)": 21.1, "Medium (40%)": 42.2, "High (70%)": 73.9 }
}

export const formatMotorPower = () => {
  return Object.keys(motorPower).map((power) => {
    return {value: power, label: power}
  });
}

export const formatEngineLoads = (power) => {
  if(!power) return [];
  return Object.keys(motorPower[power]).map((load) => {
    return {value: load, label: load}
  });
}

export const electricityEU = 0.3520797183362253;

export const formatFuelTypes = () => {
  return [{ value: 'Electricity', label: 'Electricity' }, ...Object.keys(fuels).map((type) => ({ value: type, label: type }))];
}

export const formatFuels = (type) => {
  if (!type) {
    return []
  }
  console.log(type)
  if (type === 'Electricity') {
    return [];
  }
  return Object.keys(fuels[type]).map((fuel) => ({ value: fuels[type][fuel], label: fuel }))
}



